import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хэрэглэгчийн мэдээлэл")
const _hoisted_5 = { class: "card shadow mb-5 mb-xl-10" }
const _hoisted_6 = { class: "card-body pt-9 pb-0" }
const _hoisted_7 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_8 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_13 = { class: "btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 pe-5" }
const _hoisted_15 = { class: "d-flex align-items-center text-gray-600 text-hover-primary mb-2" }
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6 pe-5" }
const _hoisted_17 = { class: "d-flex align-items-center text-gray-600 text-hover-primary mb-2" }
const _hoisted_18 = { class: "d-flex flex-wrap fw-bold fs-6 pe-5" }
const _hoisted_19 = { class: "d-flex align-items-center text-gray-600 text-hover-primary mb-2" }
const _hoisted_20 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_21 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-600" }, " Байгууллагын дугаар ", -1)
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "fs-2 fw-bolder" }
const _hoisted_27 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-600" }, " Идэвхтэй эсэх ", -1)
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "fs-2 fw-bolder" }
const _hoisted_31 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-600" }, " Locked ", -1)
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "fs-2 fw-bolder" }
const _hoisted_35 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-600" }, " Expired ", -1)
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = { class: "fs-2 fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (this.loading)
            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 0,
                rows: 5,
                animated: ""
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("a", _hoisted_12, _toDisplayString(this.userdata.name2), 1),
                      _createElementVNode("a", _hoisted_13, _toDisplayString(this.userdata.username), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", _hoisted_15, " Цахим шуудан: " + _toDisplayString(this.userdata.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("a", _hoisted_17, " Утас: " + _toDisplayString(this.userdata.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", _hoisted_19, " IP хаяг: " + _toDisplayString(this.userdata.ipaddress), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(this.userdata.orgcode), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(this.userdata.enabled ? "Тийм" : "Үгүй"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(this.userdata.accountLocked ? "Тийм" : "Үгүй"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(this.userdata.accountExpired ? "Тийм" : "Үгүй"), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}